import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageBanner() {
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bannerID, setBannerID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    title: "",
    description: "",
    image: "",
  });

  const columns = [
    {
      name: "S.No.",
      selector: (row) => row.sln,
      sortable: true,
      width: "8%",
      center: true,
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={row.image || "placeholder-image-url"}
          alt={row.title}
          style={{
            maxHeight: "250px",
            width: "250px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      ),
      // width: "12%",
      center: true,
    },
    { name: "Title", selector: (row) => row.title, wrap: true, center: true },
    {
      name: "Description",
      selector: (row) => row.description,
      wrap: true,
      // width: "35%",
      center: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.status ? "success" : "danger"}`}
          onClick={() => toggleStatus(row.id, row.status)}
          style={{ padding: "5px 10px", fontSize: "12px" }}
        >
          {row.status ? "Active" : "Inactive"}
        </button>
      ),
      // width: "10%",
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
                borderRadius: "5px",
              }}
            ></i>
          </span>
          <span title="Delete" onClick={() => handleDelete(row.id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
                borderRadius: "5px",
              }}
            ></i>
          </span>
        </>
      ),
      // width: "10%",
      center: true,
    },
  ];

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await HomeService.updateBannerStatus(id, { status: newStatus });
      toast.success("Status updated successfully!");
      fetchAllData();
    } catch (error) {
      toast.error("Failed to update status.");
      console.error("Error updating status:", error);
    }
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getBanner();
      const arr = res?.data?.map((ele, ind) => ({
        sln: ind + 1,
        title: ele.title,
        description: ele.description,
        image: ele.image,
        status: ele.status,
        id: ele._id,
      }));
      setAllData(arr);
    } catch (error) {
      console.error("Error fetching banners:", error);
      toast.error("Failed to load banners!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({
      title: row.title,
      description: row.description,
      image: row.image,
    });
    setBannerID(row.id);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Banner?",
      text: "Are you sure you want to delete this banner?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await HomeService.deleteBanner(id);
        Swal.fire("Deleted!", "Banner has been deleted.", "success");
        fetchAllData();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Banner.", "error");
      }
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const data = new FormData();
    data.append("image", file);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setEditData({ ...editData, image: res.image });
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      toast.error("Failed to upload image.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!editData.title.trim()) {
      toast.error("Please enter banner title");
      return;
    }
    if (!editData.description.trim()) {
      toast.error("Please enter banner description");
      return;
    }
    if (!editData.image) {
      toast.error("Please upload banner image");
      return;
    }

    try {
      const data = {
        title: editData.title,
        description: editData.description,
        image: editData.image,
      };

      if (isEdit) {
        // Using the updateBanner function you provided
        const res = await HomeService.updateBanner(bannerID, data);
        if (res?.status) {
          toast.success("Banner updated successfully!");
          setIsEdit(false);
          setEditData({ title: "", description: "", image: "" });
          setBannerID("");
          fetchAllData();
        } else {
          toast.error(res?.message || "Failed to update banner");
        }
      }
    } catch (error) {
      toast.error("Failed to save banner.");
      console.error("Error saving banner:", error);
    }
  };

  const handleCancelEdit = () => {
    setIsEdit(false);
    setEditData({ title: "", description: "", image: "" });
    setBannerID("");
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {/* Edit Form - Shows only when isEdit is true */}
          {isEdit && (
            <section className="chartBox_area" style={{ marginBottom: "30px" }}>
              <h2>Edit Banner</h2>
              <hr />
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12 mt-3">
                    <label htmlFor="bannerTitle">
                      Banner Title<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="bannerTitle"
                      className="form-control"
                      value={editData.title}
                      onChange={(e) =>
                        setEditData({ ...editData, title: e.target.value })
                      }
                      placeholder="Enter Banner Title"
                      required
                    />
                  </div>

                  <div className="col-md-12 mt-3">
                    <label htmlFor="bannerDescription">
                      Banner Description<span className="text-danger">*</span>
                    </label>
                    <textarea
                      id="bannerDescription"
                      className="form-control"
                      rows="4"
                      value={editData.description}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          description: e.target.value,
                        })
                      }
                      placeholder="Enter Banner Description"
                      required
                    />
                  </div>

                  <div className="col-md-6 mt-3">
                    <label htmlFor="bannerImage">
                      Banner Image<span className="text-danger">*</span>
                    </label>
                    {editData.image && (
                      <div style={{ marginBottom: "10px" }}>
                        <img
                          src={editData.image}
                          alt="Banner Preview"
                          style={{
                            maxHeight: "100px",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                            padding: "5px",
                          }}
                        />
                      </div>
                    )}
                    <input
                      type="file"
                      id="bannerImage"
                      className="form-control"
                      onChange={handleImageUpload}
                      accept="image/*"
                    />
                    <small className="text-muted">
                      Upload JPG, JPEG or PNG image
                    </small>
                  </div>
                </div>
                <div className="mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "8px",
                      border: "none",
                      padding: "8px 20px",
                    }}
                  >
                    Save Changes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mt-3"
                    style={{ marginLeft: "11px", borderRadius: "8px" }}
                    onClick={handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          )}

          {/* Banner List Table */}
          <div className="mt-4">
            <div style={headLineStyle} className="page-headline">
              Manage Banner
            </div>
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <section className="chartBox_area">
                <DataTable
                  columns={columns}
                  data={allData}
                  pagination
                  responsive
                  highlightOnHover
                  noDataComponent="No banners found"
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                />
              </section>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageBanner;
